/*document.addEventListener("DOMContentLoaded", () => {
  const productCards = document.querySelectorAll("product-card[handle]");

  productCards.forEach(card => {
    const handle = card.getAttribute("handle");

    fetch(`https://widebundle.com/scripttagAjax.php?shop=bosworthsgc.myshopify.com&productHandle=${handle}`)
      .then(response => response.json())
      .then(data => {
        if (data.variants && data.variants.length > 0) {
          // Extract unique offer names, excluding "1 Product"
          const allOfferNames = [...new Set(
            data.variants
              .map(v => v.variant_option1)
              .filter(name => name && name.toLowerCase() !== "1 product")
          )];

          if (allOfferNames.length > 0) {
            // Use the first "real" offer for the badge
            const badge = document.createElement("span");
            badge.className = "discount-badge";
            badge.innerText = allOfferNames[0];

            // Insert badge into product card
            const target = card.querySelector(".product-card__figure");
            if (target) target.appendChild(badge);
          }
        }
      })
      .catch(err => console.log(`${handle} – no bundle data`, err));
  });
});
*/

function processProductCard(card) {
  const handle = card.getAttribute("handle");
  if (!handle) return;

  // Avoid duplicates
  if (card.querySelector(".discount-badge")) return;

  fetch(`https://widebundle.com/scripttagAjax.php?shop=bosworthsgc.myshopify.com&productHandle=${handle}`)
    .then(r => r.json())
    .then(data => {
      if (data.variants && data.variants.length > 0) {
        const offers = data.variants
          .map(v => v.variant_option1)
          .filter((name, i, arr) => arr.indexOf(name) === i && name !== "1 Product");

        if (offers.length > 0) {
          const badge = document.createElement("span");
          badge.className = "discount-badge";
          badge.textContent = offers[0]; // just take the first non-standard offer
          card.querySelector(".product-card__figure")?.appendChild(badge);
        }
      }
    })
    .catch(() => {});
}

// Run initially on all visible product cards
document.querySelectorAll("product-card").forEach(processProductCard);

// Watch for dynamically added product-cards (recently viewed, upsells, etc.)
const observer = new MutationObserver(mutations => {
  mutations.forEach(m => {
    m.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.tagName.toLowerCase() === "product-card") {
        processProductCard(node);
      }
      // Also check if product-cards are inside containers that got injected
      node.querySelectorAll?.("product-card").forEach(processProductCard);
    });
  });
});
observer.observe(document.body, { childList: true, subtree: true });
